import { Mutation } from '@apollo/client/react/components';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import LogoutIcon from '@mui/icons-material/ExitToApp';
import { withSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { REVOKE_TOKEN } from '../../helpers/graphql/token';

class LogoutButton extends Component {
  state = {
    mounted: false,
    open: false,
  };

  componentDidMount() {
    this.setState({ mounted: true });
  }

  newNotification(notification) {
    if (notification !== undefined) {
      let variant = 'success';
      if (notification.success === false) {
        variant = 'error';
      }
      const { enqueueSnackbar } = this.props;
      enqueueSnackbar(notification.message, { variant });
    }
  }

  render() {
    //   No ssr - need to read cookies
    if (!this.state.mounted) {
      return '';
    }
    return (
      <Mutation mutation={REVOKE_TOKEN}>
        {(revokeToken, data) => {
          if (data && data.data && data.data.revokeToken && !this.state.open) {
            this.newNotification({
              success: data.data.revokeToken.success,
              message: data.data.revokeToken.message,
            });
            if (this.props.handleLogout) this.props.handleLogout();
            window.open('/', '_self');
            this.setState({ open: true });
          }
          return (
            (this.props.listItem && (
              <ListItem onClick={revokeToken}>
                <ListItemIcon>
                  <LogoutIcon />
                </ListItemIcon>
                <ListItemText
                  primaryTypographyProps={{ color: 'textPrimary' }}
                  primary="Logout"
                />
              </ListItem>
            )) || (
              <MenuItem onClick={revokeToken}>
                <ListItemIcon>
                  <LogoutIcon />
                </ListItemIcon>
                <ListItemText
                  primaryTypographyProps={{ color: 'textPrimary' }}
                  primary="Logout"
                />
              </MenuItem>
            )
          );
        }}
      </Mutation>
    );
  }
}

LogoutButton.propTypes = {
  enqueueSnackbar: PropTypes.func.isRequired,
  handleLogout: PropTypes.func.isRequired,
};

export default withSnackbar(LogoutButton);
